import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import IconDS22, { IconIds } from '../IconDS22';
import UniversalLink from '../UniversalLink';
import s from './Navigation.module.scss';

type NavItemProps = {
  children: React.ReactNode;
  classNameModifier?: string;
  icon?: IconIds;
  indicator?: ReactNode;
  openInNewTab?: boolean;
  to: string;
  title?: string;
  variant?: 'topNav' | 'subNav';
  disabled?: boolean;
};

const NavItem: FC<NavItemProps> = ({
  children,
  classNameModifier = '',
  icon,
  indicator,
  openInNewTab = false,
  to,
  variant,
  disabled = false,
  ...rest
}) => (
  <UniversalLink
    to={to}
    className={getClassName(s, 'link', classNames(classNameModifier))}
    openInNewTab={openInNewTab}
    aria-disabled={disabled ? 'true' : undefined}
    tabIndex={disabled ? -1 : undefined}
    {...rest}
  >
    {icon && (
      <IconDS22
        id={icon}
        size={variant === 'subNav' ? 'm' : 'l'}
      />
    )}
    <span className={getClassName(s, 'children', classNameModifier)}>{children}</span>
    {indicator}
  </UniversalLink>
);

export default NavItem;
